import PropTypes from 'prop-types'

import { useImagenPublicacion } from '../hooks/imagenPublicacion'

const Imagen = ({ idPublicacion, width, height, className = '' }) => {
  const { imagenUrl, loading } = useImagenPublicacion(idPublicacion)

  return loading ? (
    <div className="spinner-border text-secondary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  ) : (
    <img
      src={imagenUrl}
      width={width}
      height={height}
      loading="lazy"
      alt="Publicación"
      className={className}
    />
  )
}

Imagen.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
}

export default Imagen
